<section class="h-min-full-header d-flex flex-column">
	<section class="container px-0 pt-3 flex-fill d-flex flex-column">
		<h2 class="kp-title-line">{{rtwadModel.Id?'ویرایش':'ثبت'}} آگهی آماده به کار</h2>
		<div *ngIf="isOperatorMode" class="d-flex flex-wrap gap-2 ">
			<div>
				<a class="btn btn-link btn-sm fs-sm f-blue" *ngIf="rtwadModel.Id"
					[routerLink]="[rtwadPath,rtwadModel.Id]" target="_blank">مشاهده آگهی در سایت</a>
			</div>
			<div>
				<a class="btn btn-link btn-sm fs-sm f-blue" *ngIf="rtwadModel.UserId" [routerLink]="['/admin/user']"
					[queryParams]="{q: rtwadModel.UserId}" target="_blank">کاربر ثبت کننده</a>
			</div>

		</div>
		<div class="d-flex flex-wrap gap-2 fs-sm f-blue fw-bold px-2">
			<div *ngIf="rtwadModel.Code" [copy]="rtwadModel.Code">
				کد آگهی: KP{{rtwadModel.Code}} </div>
			<div *ngIf="rtwadModel.Impression!=null"> تعداد بازدید: {{rtwadModel.Impression}}</div>
			<div *ngIf="rtwadModel.GetContactCount!=null"> تعداد دریافت شماره تماس: {{rtwadModel.GetContactCount}}</div>

		</div>
		<app-login [class.d-none]="currentUser" [inline]="true" heading="" [show-name-input]="false"
			intro="برای ثبت اطلاعات شماره موبایل خود را وارد کنید">
		</app-login>
		<form *ngIf="currentUser" (ngSubmit)="submitForm(postad)" class="flex-fill d-flex gap-2"
			[class.justify-content-center]="!isOperatorMode" #postad="ngForm">
			<div class="container-capped-sm">
				<section class="kp-card m-2">
					<p class="fw-bold fs-10">اطلاعات شخصی</p>
					<!-- Add your personal info form fields here -->
					<div class="form-group">
						<label for="name">نام و نام خانوادگی</label>
						<input [(ngModel)]="rtwadModel.ContactName" name="contact-name"
							[required]="!rtwadModel.IsIndexed" type="text" class="form-control" id="name"
							placeholder="">
					</div>
					<div class="form-group">
						<label for="phone">شماره تماس</label>
						<input [(ngModel)]="rtwadModel.Phone" name="phone" [required]="!rtwadModel.IsIndexed"
							type="text" class="form-control" id="phone" placeholder="">
					</div>
					<!-- Location Component -->
					<div class="form-group">
						<label for="location">موقعیت جغرافیایی</label>
						<app-location [(ngModel)]="rtwadModel" required accept-level="Globe"
							name="location"></app-location>
					</div>
					<div class="form-group">
						<div class="form-group group-box">
							<label class="pt-1 d-inline-block">
								<input type="checkbox" name="isRemote" [(ngModel)]="rtwadModel.IsRemote">
								<span>امکان دورکاری دارد؟</span>
							</label>
						</div>
					</div>

				</section>

				<!-- Ad Details Section -->
				<section class="kp-card m-2">
					<!-- عنوان آگهی-->
					<div class="form-group">
						<label for="adTitle">عنوان آگهی</label>
						<input [(ngModel)]="rtwadModel.Title" name="title" required type="text" class="form-control"
							id="adTitle" placeholder="">
					</div>
					<!-- متن آگهی-->
					<div class="form-group">
						<label for="adText">متن آگهی</label>
						<angular-editor placeholder="توضیحات کامل  ..." name="description"
							[class.editor-ltr]="rtwadModel.IsLtr" [(ngModel)]="rtwadModel.Description"
							[config]="editorConfig">
						</angular-editor>
						<label class="pt-1 d-inline-block">
							<input type="checkbox" name="types" [(ngModel)]="rtwadModel.IsLtr">
							<span>متن آگهی به زبان انگلیسی است.</span>
						</label>

					</div>
					<!-- برچسب‌ها -->
					<div class="form-group">
						<label>برچسب‌ها</label>
						<app-option-selector [(ngModel)]="rtwadModel.Tags" name="tags" [multiple]="true" [canAdd]="true"
							itemClass="" [placeholder]="'مهارت، خدمات، شغل و ...'"></app-option-selector>
					</div>

					<!-- آپلود تصویر-->
					<div class="form-group">
						<label for="pictureUpload">تصاویر آگهی <br />
							<small class="text-muted">وجود تصویر در آگهی شانس دیده‌شدن آن را افزایش می‌دهد.</small>
						</label>
						<div class="d-flex gap-2 flex-wrap p-2">
							<div *ngFor="let file of rtwadModel.Images;let i=index" class="relative">
								<img [src]="file.startsWith('http') ? file : imagePath + file + '?size=128'"
									class="cover loading border rounded-xxl" style="width:128px;aspect-ratio: 1/1;"
									(click)="previewImageSrc=file.startsWith('http') ? file : imagePath + file;previewModal.open()">
								<div class="absolute z-1 btn btn-icon btn-red btn-sm left-0 top-0"
									(click)="rtwadModel.Images.splice(i,1)"><i class="fa fa-times"></i></div>
							</div>
						</div>
						<div>
							<button type="button" class="btn btn-transparent-border p-2 mr-2 d-flex"
								(click)="fileInput.click()">
								<i class="fa fa-paperclip fs-xl"></i>افزودن تصویر
							</button>
						</div>
						<input #fileInput type="file" style="display:none" (change)="onFileChange($event.target.files)"
							multiple accept=".jpg,.jpeg,.png">
						<div class="d-flex gap-2 flex-wrap p-2">
							<div *ngFor="let image of images;let i=index" class="relative">
								<img [src]="image._dataUrl" class="cover loading border rounded-xxl"
									style="width:128px;aspect-ratio: 1/1;">
								<div class="absolute z-1 btn btn-icon btn-red btn-sm left-0 top-0"
									(click)="images.splice(i,1)"><i class="fa fa-times"></i></div>
							</div>
						</div>
					</div>
				</section>

				<section *ngIf="!isOperatorMode && rtwadModel.Status!='Pending' " class="kp-card mx-0">
					<h5>مزایای ثبت آگهی آماده به کار در کارپیشه</h5>
					<div><i class="fa fa-check ml-1 f-green"></i> نمایش آگهی شما
						بالاتر از هزاران آگهی از وبسایت‌های دیگر </div>
					<div><i class="fa fa-check ml-1 f-green"></i> معرفی قابلیت‌های شما به جویندگان نیرو و خدمات</div>
					<div><i class="fa fa-check ml-1 f-green"></i>اولویت‌ها و شرایط کاریتان را به اطلاع متقاضیان برسانید
					</div>
					<div><i class="fa fa-check ml-1 f-green"></i><b>هزینه پخش آگهی فقط {{toPay|number}} تومان</b></div>
					<!---->
				</section>
				<section *ngIf="!isOperatorMode">
					<button class="btn btn-primary no-disabled w-100 mb-5" type="submit" [disabled]="postad.invalid"> {{
						rtwadModel.IsPaid || rtwadModel.Status === 'Pending' ? 'ذخیره' : 'ثبت آگهی و پرداخت' }}</button>
				</section>
				<!-- Personal Info Section -->
			</div>
			<div class="flex-grow-1" *ngIf="isOperatorMode">
				<section class="kp-card m-2">
					<p class="fw-bold fs-10">دسترسی اپراتور</p>
					<div class="form-group">
						<label for="status">وضعیت</label>
						<select [(ngModel)]="rtwadModel.Status" name="status" class="form-control">
							<option *ngFor='let status of ["NotPaid","Pending","Started","Rejected"]' [value]="status">
								{{status |
								readable:"RtwadStatus"}}</option>
						</select>
					</div>
					<button class="btn btn-primary no-disabled w-100 " type="button"
						(click)="!postad.invalid && saveAdmin()" [disabled]="postad.invalid"> ذخیره آگهی آماده
						به کار
					</button>
					<section *ngIf="rtwadModel.Id" class="mt-3">
						<button type="button" class="btn btn-red w-100" (click)="deleteRtwad()"
							>حذف آگهی
						</button>
					</section>

				</section>
				<section class="kp-card m-2">
					<app-activity [inline]="true" [rtwad]="rtwadModel.Id" [user]="rtwadModel.UserId"
						[limit]="1000"></app-activity>
				</section>
			</div>
		</form>
	</section>
</section>

<ngx-smart-modal #paymentModal identifier="paymentModal">
	<ngx-spinner name="payment" [fullScreen]="false" type="timer"></ngx-spinner>
	<div class="d-flex flex-column container-capped-sm f-initial text-right py-2">
		<div class="border-bottom mb-3">
			<!-- <div class="text-center green-bg f-white fw-bold fs-lg">پرداخت شما ضمانت بازگشت وجه دارد!</div> -->
			<h5 class="kp-title-line mb-2">
				یک روش رو از زیر انتخاب کن
			</h5>
		</div>
		<div class="mb-2 pb-2 border-bottom pointer" (click)="pay()">
			<div class="h6">پرداخت از طریق درگاه اینترنتی</div>
			<div class="f-gray">توجه: نیاز به رمز دوم یا رمز پویا دارد.</div>
			<div class="text-left ">
				<button class="btn btn-primary my-2 flex-column">پرداخت آنلاین </button>
			</div>
		</div>
		<div class="mb-2 pb-2 pointer" (click)="manualModal.open()">
			<div class="h6">پرداخت از طریق کارت به کارت</div>
			<div class="f-gray">از طریق <b>دستگاه خودپرداز(ATM)</b> یا نرم‌افزارهای انتفال وجه مانند
				<b>آپ و همراه کارت و ...</b>
			</div>
			<div class="text-left ">
				<button class="btn btn-primary my-2 flex-column">پرداخت کارت به کارت </button>
			</div>
		</div>
	</div>
</ngx-smart-modal>

<app-manual-payment-modal #manualModal [amount]="toPay" (submitPayment)="pay($event)"></app-manual-payment-modal>

<ngx-smart-modal #previewModal identifier="previewModal">
	<img *ngIf="previewImageSrc && previewModal.visible" [src]="previewImageSrc" class="mw-100">
</ngx-smart-modal>